module.exports = __webpack_public_path__ + "img/guerraoui.71a84218.jpg";